export const JOURNAL_TYPES = [
  {
    group: "Operational Adjustments",
    types: [
      {
        value: "accrual",
        label: "Accrual",
        description:
          "For expenses or revenues recognized before cash is paid/received",
        color: "primary",
      },
      {
        value: "reversal",
        label: "Reversal",
        description: "Mirror entry to neutralize a previous journal",
        color: "secondary",
      },
      {
        value: "reclassification",
        label: "Reclassification",
        description: "Move balances between accounts without affecting totals",
        color: "info",
      },
      {
        value: "correction",
        label: "Correction",
        description:
          "Fix mistakes from prior entries (e.g., wrong account used)",
        color: "warning",
      },
    ],
  },
  {
    group: "Period-End",
    types: [
      {
        value: "closing_entry",
        label: "Closing Entry",
        description:
          "Used to close temporary accounts (e.g., Revenue to Retained Earnings)",
        color: "success",
      },
      {
        value: "opening_balance",
        label: "Opening Balance",
        description: "Used to set up initial balances during system setup",
        color: "primary",
      },
      {
        value: "depreciation",
        label: "Depreciation",
        description: "Monthly depreciation expense allocation",
        color: "warning",
      },
      {
        value: "amortization",
        label: "Amortization",
        description: "For prepaid assets or intangible amortization",
        color: "info",
      },
    ],
  },
  {
    group: "Internal Allocations",
    types: [
      {
        value: "interdepartmental_allocation",
        label: "Interdepartmental Allocation",
        description:
          "Allocate shared costs (e.g., utilities across departments)",
        color: "secondary",
      },
      {
        value: "cost_center_transfer",
        label: "Cost Center Transfer",
        description: "Move balances between cost centers",
        color: "primary",
      },
      {
        value: "inventory_adjustment",
        label: "Inventory Adjustment",
        description: "Stock valuation corrections impacting accounting",
        color: "warning",
      },
    ],
  },
  {
    group: "External Events",
    types: [
      {
        value: "audit_adjustment",
        label: "Audit Adjustment",
        description: "Posted after external/internal audits",
        color: "error",
      },
      {
        value: "legal_settlement",
        label: "Legal Settlement",
        description: "Related to legal or contractual settlements",
        color: "warning",
      },
      {
        value: "miscellaneous",
        label: "Miscellaneous",
        description: "When no other category applies (rare usage only)",
        color: "secondary",
      },
    ],
  },
] as const;

export const CURRENCIES = [
  { value: "BHD", label: "Bahraini Dinar (BHD)" },
] as const;

export const FORM_DEFAULTS = {
  ENTRY_DATE: new Date(),
  NARRATION: "",
  REFERENCE_ID: "",
  BRANCH_ID: "organization",
  CURRENCY: "BHD",
  JOURNAL_TYPE: "",
  MINIMUM_LINES: 2,
} as const;

export const VALIDATION_MESSAGES = {
  ENTRY_DATE_REQUIRED: "Journal date is required",
  NARRATION_REQUIRED: "Narration is required",
  BRANCH_REQUIRED: "Branch is required",
  ACCOUNT_REQUIRED: "Account is required",
  AMOUNT_REQUIRED: "Either debit or credit amount is required",
  BOTH_AMOUNTS_ERROR: "Cannot have both debit and credit amounts",
  NEGATIVE_DEBIT: "Debit amount cannot be negative",
  NEGATIVE_CREDIT: "Credit amount cannot be negative",
  UNBALANCED_ENTRY: "Entries are not balanced. Difference:",
} as const;

export const UI_CONFIG = {
  DIALOG_MAX_HEIGHT: "90vh",
  MENU_MAX_HEIGHT: 400,
  TOOLTIP_ENTER_DELAY: 300,
  BALANCE_PRECISION: 0.01,
} as const;
